import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/InventoryStyle.scss';
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiOutlineFilePdf, AiOutlineClose, AiOutlineReload } from "react-icons/ai";
import { SiHyperledger } from "react-icons/si";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { errorAlert } from "../../Components/Alerts";
import DataGridShowDetails from "../../Components/DataGridShowDetails";
import DataGridComponent from "../../Components/DataGridComponent";
import { InventoryDataGrid, InventoryDetails } from "./AccountingReports_DataGrid/InventoryDataGrid";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddActionsButton } from "../../Components/AddElementsButton";
import TextField from '@mui/material/TextField';
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { inventoryColumns, inventoryDetailsColumns, inventoryDetailsMappings, inventoryMappings } from "../../Components/ExcelConverter/AccountingReportsHeader";
import OneFieldTotal from "../../Components/OneFieldTotal";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";

export default function Inventory() {
    const [data, setData] = useState([]);
    const [articleDetails, setArticleDetails] = useState([]);
    const { fiscalYear } = useContext(FiscalYearContext);
    const [showallAccounts, setShowAllAccounts] = useState(true);
    const [showDetailAccounts, setShowDetailsAccounts] = useState(false);

    const [ngaData, setNgaData] = useState("");
    const [deriData, setDeriData] = useState("");

    const [pdfDate, setPdfDate] = useState("");

    const [articleDetailName, setArticleDetailName] = useState("");

    const [showDatesField, setShowDatesField] = useState(false);

    const headers = authHeader();

    const [searchTerm, setSearchTerm] = useState("");
    const [companiesData, setCompaniesData] = useState([]);
    const [logoPath, setLogoPath] = useState("");
    let number = 1;

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const showDetails = () => {
        setShowAllAccounts(false);
        setShowDetailsAccounts(true);
    }
    const showAllAccounts = () => {
        setShowAllAccounts(true);
        setShowDetailsAccounts(false);
        setArticleDetails([]);
    }

    function formatDate(date) {
        if (!date) return '';

        // Parse the date string into a Date object if it's not already one
        const d = (date instanceof Date) ? date : new Date(date);

        // Format the date components
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // January is 0!
        // const year = d.getFullYear();

        return `${day}/${month}/${fiscalYear}`;
    }

    const addLogo = (doc) => {
        const logoWidth = 30;
        const logoHeight = 30;
        const logoX = 10;
        const logoY = 5;
        doc.addImage(logoPath, 'JPEG', logoX, logoY, logoWidth, logoHeight);
    };

    const addSeparatorLine = (doc, lineY) => {
        const lineWidth = doc.internal.pageSize.getWidth() - 10;
        doc.line(10, lineY, 10 + lineWidth, lineY);
    };

    const addLeftText = (doc, text, lineY) => {
        doc.setFontSize(10);
        doc.text(text, 10, lineY + 10);
    };

    const addCompanyDetails = (doc, companyData) => {
        doc.setFontSize(10);
        const companyDetails = `
            ${companyData.CompanyName}
            NUI/NF: ${companyData.IdentificationNumber}
            Business Number:${companyData.IdentificationNumber}
            Address: ${companyData.Address}
            Tel: ${companyData.PhoneNumbers}
            Email: ${companyData.Email}
        `;
        doc.text(companyDetails, doc.internal.pageSize.getWidth() - 10, 5, { align: "right" });
    };

    const addTable = (doc, data, lineY) => {
        let totalQtyInput = 0;
        let totalQtyOutput = 0;
        let totalStok = 0;
        let totalAmount = 0;

        const bodyData = filteredData.map((item, index) => {
            totalQtyInput += item.TotalQtyInput;
            totalQtyOutput += item.TotalQtyOutput;
            totalStok += item.TotalQtyInStock;
            totalAmount += item.TotalAmount;

            return [
                (number + index),
                item.ArticleName,
                item.Barcode,
                item.ArticleGroupName,
                item.ArticleUnitName,
                item.TotalQtyInput !== null && item.TotalQtyInput !== 0 ? item.TotalQtyInput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
                item.TotalQtyOutput !== null && item.TotalQtyOutput !== 0 ? item.TotalQtyOutput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
                item.TotalQtyInStock !== null && item.TotalQtyInStock !== 0 ? item.TotalQtyInStock.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
                item.CmimiMesatar !== null && item.CmimiMesatar !== 0 ? item.CmimiMesatar.toLocaleString('en-US', { minimumFractionDigits: 4 }) : '-',
                item.TotalAmount !== null && item.TotalAmount !== 0 ? item.TotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
            ];
        });

        // Shtoni rreshtin e totalit në fund të tabelës
        bodyData.push([
            '', '', '', '', 'Totali:',
            totalQtyInput !== null && totalQtyInput !== 0 ? totalQtyInput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00',
            (totalQtyOutput !== null && totalQtyOutput !== 0) ? totalQtyOutput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00',
            (totalStok !== null && totalStok !== 0) ? totalStok.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00',
            "",
            (totalAmount !== null && totalAmount !== 0) ? totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'
        ]);

        doc.autoTable({
            head: [["#", "Artikulli", "Barkodi", "Grupi artikullit ", "Njësia e artikullit", " Sasia blerjeve", "Sasia shitjeve", "Sasia në stok", "Cmimi Mesatar", "Vlera"]],
            body: bodyData,
            startY: lineY + 30,
            columnStyles: {
                2: { cellWidth: 'wrap' }, // Kolona 2, ku është "Invoice Number"
            },
            didDrawCell: (data) => {
                if (data.row.index === bodyData.length - 1) { // Kontrolloni nëse është rreshti i fundit (totali)
                    // Cakto ngjyrën e sfondit dhe të tekstit për rreshtin e totalit
                    doc.setFillColor(220, 220, 220); // Ngjyra e sfondit në hiri
                    doc.setTextColor(0, 0, 0); // Ngjyra e tekstit në të bardhë
                    doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F'); // Vizato një drejtkëndësh me këtë ngjyrë

                    // Vizato tekstin manualisht
                    if (data.cell.text) {
                        doc.text(data.cell.text, data.cell.x + 2, data.cell.y + data.cell.height - 2);
                    }
                }
            }
        });
    };

    const handleExportPDF = () => {
        const doc = new jsPDF({
            orientation: "landscape",
        });

        const tableMargin = 20;
        const lineY = 30 + tableMargin - 5;

        addLogo(doc);
        addSeparatorLine(doc, lineY);
        // addLeftText(doc, "Stoku", lineY);
        if (showDatesField) {
            addLeftText(doc, `Stoku për periudhën ${formatDate(ngaData)} - ${formatDate(deriData)}`, lineY);
        }
        else {
            addLeftText(doc, `Stoku me datën: ${pdfDate}`, lineY);
        }

        addCompanyDetails(doc, companiesData[0]);
        addTable(doc, filteredData, lineY);

        doc.save("Gjendja_Stokut.pdf");
    };

    const addSecondTable = (doc, data, lineY) => {
        let totalQtyInput = 0;
        let totalQtyOutput = 0;
        let progresive = 0;

        const bodyData = filteredDetails.map((item, index) => {
            totalQtyInput += item.QTYInput;
            totalQtyOutput += item.QtyOutput;
            progresive += item.Progressive;

            return [
                (number + index),
                item.ActionType,
                item.Barcode,
                item.ArticleName,
                item.PartnerName,
                item.Date,
                item.PriceWithoutVAT !== null && item.PriceWithoutVAT !== 0 ? item.PriceWithoutVAT.toLocaleString('en-US', { minimumFractionDigits: 4 }) : '-',
                item.QTYInput !== null && item.QTYInput !== 0 ? item.QTYInput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
                item.QtyOutput !== null && item.QtyOutput !== 0 ? item.QtyOutput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-',
                item.Progressive !== null && item.Progressive !== 0 ? item.Progressive.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-'
            ];
        });

        // Shtoni rreshtin e totalit në fund të tabelës
        bodyData.push([
            '', '', '', '', '', "", 'Totali:',
            (totalQtyInput !== null && totalQtyInput !== 0) ? totalQtyInput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00',
            (totalQtyOutput !== null && totalQtyOutput !== 0) ? totalQtyOutput.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00',
            (progresive !== null && progresive !== 0) ? progresive.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00',
        ]);

        doc.autoTable({
            head: [["#", "Tipi Veprimit", "Barkodi", "Emri Artikullit", "Emri i Partnerit", "Data", "Cmimi Pa TVSH", "Sasia Hyrje", "Sasia Dalje", "Progresive"]],
            body: bodyData,
            startY: lineY + 30,
            columnStyles: {
                2: { cellWidth: 'wrap' },
            },
            didDrawCell: (data) => {
                if (data.row.index === bodyData.length - 1) { // Kontrolloni nëse është rreshti i fundit (totali)
                    // Cakto ngjyrën e sfondit dhe të tekstit për rreshtin e totalit
                    doc.setFillColor(220, 220, 220); // Ngjyra e sfondit në hiri
                    doc.setTextColor(0, 0, 0); // Ngjyra e tekstit në të bardhë
                    doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F'); // Vizato një drejtkëndësh me këtë ngjyrë

                    // Vizato tekstin manualisht
                    if (data.cell.text) {
                        doc.text(data.cell.text, data.cell.x + 2, data.cell.y + data.cell.height - 2);
                    }
                }
            }
        });
    };

    const handleExportSecondPDF = () => {
        const doc = new jsPDF({
            orientation: "landscape",
        });

        const tableMargin = 20;
        const lineY = 30 + tableMargin - 5;

        addLogo(doc);
        addSeparatorLine(doc, lineY);
        addLeftText(doc, "Kartela Artikullit", lineY);
        addCompanyDetails(doc, companiesData[0]);
        addSecondTable(doc, filteredDetails, lineY);

        doc.save("ArticleDetailsInventory.pdf");
    };
    // const ledger = 101;
    // Kodi per Marrjen e informatave nga databaza
    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingBooks/inventory', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
            setNgaData("");
            setDeriData("");
            setShowDatesField(false);
        } catch (error) {
            // console.log(error);
        }
    };

    const fetchArticleDetails = async (articleID, fiscalY) => {
        showDetails();
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingBooks/StokuDetale', { headers, params: { articleID: articleID, fiscalYear: fiscalY } });
            setArticleDetails(response.data);
            setArticleDetailName(response.data[0].ArticleName)
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchinventoryByDates = async (nga, deri) => {
        if (nga > deri) {
            errorAlert("Data Deri duhet te jete me i madh ose e ngjajshme me daten Nga")
        }
        else {
            try {
                const response = await axios.get(ApiLink.API_URL + 'AccountingBooks/inventoryBasedOnDate', { headers, params: { fromDate: nga, toDate: deri } });
                setData(response.data);
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    // Kthehet nga serveri për mungesë qasje
                } else {
                    errorAlert("Gabim në kërkesë:", error);

                    if (error.response && error.response.data && error.response.data.errorMessage) {
                        errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
                    } else if (error.message) {
                        errorAlert(`Gabim: ${error.message}`);
                    } else {
                        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
                    }
                }
            }
        }
    };

    const showFields = () => {
        setShowDatesField(true);
        setData([]);
    }

    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyDetails', { headers });
            setCompaniesData(response.data);
            setLogoPath(ApiLink.PHOTO_URL + response.data[0].CompanyLogo);

            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };
    const filteredData = data.filter((item) => {
        return (
            item.ArticleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.Barcode.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    const filteredDetails = articleDetails.filter((item) => {
        return (
            item.ArticleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.Barcode.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.ActionType.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    const totali = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TotalAmount), 0);
    }, [data]);


    const rows = data.map((item, index) => ({
        id: ++index,
        // accID: item.AccountID,
        accName: item.ArticleName,
        barcode: item.Barcode,
        group: item.ArticleGroupName,
        unit: item.ArticleUnitName,
        qtyInput: item.TotalQtyInput,
        qtyOutput: item.TotalQtyOutput,
        qtyStok: item.TotalQtyInStock,
        price: item.CmimiMesatar,
        total: item.TotalAmount,
        showDetails: item.ArticleID,
        rowInfo: item
    }));

    const qtyInputTotal = useMemo(() => {
        return articleDetails.reduce((sum, item) => sum + Number(item.QTYInput), 0);
    }, [articleDetails]);

    const qtyOutputTotal = useMemo(() => {
        return articleDetails.reduce((sum, item) => sum + Number(item.QtyOutput), 0);
    }, [articleDetails]);

    const progresiveTotal = useMemo(() => {
        // return data.reduce((sum, item) => sum + ((Number(item.Debit) - Number(item.Credit))), 0);
        return articleDetails.reduce((sum, item) => sum + ((Number(item.QTYInput) - Number(item.QtyOutput))), 0);

    }, [articleDetails]);

    const detailsRows = articleDetails.map((item, index) => ({
        id: ++index,
        type: item.ActionType,
        barcode: item.Barcode,
        articleName: item.ArticleName,
        accName: item.PartnerName,
        date: item.Date,
        priceNoVAT: item.PriceWithoutVAT,
        qtyInput: item.QTYInput,
        qtyOutput: item.QtyOutput,
        progresive: item.Progressive,
    }));

    const xlsName = (showDatesField ?
        (`Stoku_Periudha: ${formatDate(ngaData)} deri ${formatDate(deriData)}`) :
        (`Stoku_Total`)
    )

    useEffect(() => {
        if (ngaData && ngaData !== "" && deriData && deriData !== "") {
            fetchinventoryByDates(ngaData, deriData);
        }
    }, [ngaData, deriData]);

    useEffect(() => {

        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // muajt fillojnë nga 0
        const year = currentDate.getFullYear();

        const formattedDate = `${day}/${month}/${year}`;
        const currentYear = currentDate.getFullYear();

        if (fiscalYear < currentYear) {
            setPdfDate(`31/12/${fiscalYear}`)
        }
        else {
            setPdfDate(formattedDate);
        }

    })

    useEffect(() => {
        fetchData();
        fetchCompaniesData();
    }, [fiscalYear]);

    return (
        <div className="Inventory__Container">
            {showallAccounts && (
                <>
                    <div className="Inventory__Container__Header">
                        <div className="Inventory__Container__Header__Top">
                            <TitleElements
                                icon={SiHyperledger}
                                title="Stoku"
                            />

                            <ElementsParagraph text="Kjo formë është e përshtatur për shtypje dhe përdorim në dokumentacionin fizik." />
                        </div>
                        <div className="Inventory__Container__Header__Bottom">
                            <div className="Inventory__Container__Header__Bottom__Right">
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <AddActionsButton
                                        text="PDF"
                                        onClick={handleExportPDF}
                                        icon={<AiOutlineFilePdf />}
                                        className="button-15"
                                    />

                                    <ExcelFormat
                                        data={data}
                                        fileName={xlsName}
                                        columns={inventoryColumns}
                                        columnMappings={inventoryMappings}
                                        buttonText="XLSX"
                                    />
                                </div>
                            </div>
                            <div className="Inventory__Container__Header__Bottom__Left">
                                {
                                    showDatesField ?
                                        <div>
                                            <AddActionsButton
                                                text="Shfaq stokun momental"
                                                onClick={() => fetchData()}
                                                // icon={<AiOutlineFilePdf />}
                                                className="button-15"
                                            />
                                            <TextField
                                                className="AccountingBooks__Container__SearchSection__Search__Input__Month"
                                                id="date"
                                                type="date"
                                                variant="outlined"
                                                name='Date'
                                                label="Nga"
                                                value={ngaData}
                                                onChange={(e) => { setNgaData(e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    min: minDate,
                                                    max: maxDate,
                                                }}
                                            />
                                            <TextField
                                                className="AccountingBooks__Container__SearchSection__Search__Input__Month"
                                                id="date"
                                                type="date"
                                                variant="outlined"
                                                name='Date'
                                                label="Deri"
                                                value={deriData}
                                                onChange={(e) => { setDeriData(e.target.value); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    min: minDate,
                                                    max: maxDate,
                                                }}
                                            />
                                        </div>
                                        :
                                        <AddActionsButton
                                            text="Filtro stokun sipas datave"
                                            onClick={showFields}
                                            // icon={<AiOutlineFilePdf />}
                                            className="button-15"
                                        />
                                }
                            </div>

                        </div>
                    </div>
                    <DataGridShowDetails
                        columns={InventoryDataGrid}
                        rows={rows}
                        fetchAccountsDetails={fetchArticleDetails}
                        height={500}
                    />
                    <OneFieldTotal
                        id={1}
                        label="Total"
                        value={totali}
                    />
                </>
            )}
            {showDetailAccounts && (
                <>
                    <TitleElements
                        icon={SiHyperledger}
                        title="Kartela Artikullit"
                    />
                    <div className="bordere">
                        <div style={{ display: "flex", gap: "10px" }}>
                            {/* <button className="button-15" onClick={handleExportSecondPDF} variant="contained"><AiOutlineFilePdf /> PDF </button> */}
                            <AddActionsButton
                                text="PDF"
                                onClick={handleExportSecondPDF}
                                icon={<AiOutlineFilePdf />}
                                className="button-15"
                            />

                            <ExcelFormat
                                data={articleDetails}
                                fileName={`${articleDetailName}-StokuDetaje`}
                                columns={inventoryDetailsColumns}
                                columnMappings={inventoryDetailsMappings}
                                buttonText="XLSX"
                            />
                        </div>
                        <div className="butons15">
                            {/* <button className="button-15" variant="contained" onClick={showAllAccounts}><AiOutlineClose /> Mbyll</button> */}
                            <AddActionsButton
                                text="Mbyll"
                                onClick={showAllAccounts}
                                icon={<AiOutlineClose />}
                                className="button-15"
                            />
                        </div>
                    </div>
                    <DataGridComponent columns={InventoryDetails} rows={detailsRows} />
                    <TotalSummaryComponent
                        fields={[
                            { id: 1, label: 'Sasia Hyrje', value: qtyInputTotal },
                            { id: 2, label: 'Sasia Dalje', value: qtyOutputTotal },
                            { id: 3, label: 'Progresive', value: progresiveTotal },
                        ]}
                    />
                </>
            )}
        </div>
    )
}